module.exports = __webpack_public_path__ + "@/assets/img/compiling.1d343304.svg";